import { render, staticRenderFns } from "./MavBadge.vue?vue&type=template&id=2c405a70&scoped=true"
import script from "./MavBadge.vue?vue&type=script&lang=js"
export * from "./MavBadge.vue?vue&type=script&lang=js"
import style0 from "./MavBadge.vue?vue&type=style&index=0&id=2c405a70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c405a70",
  null
  
)

export default component.exports